const NEXT_PUBLIC_FB_APP_ID = process.env.NEXT_PUBLIC_FB_APP_ID;
export const handleShare = (event:any, value: string) => {
  event.preventDefault();
  let obj = {
    href:
      `https://www.facebook.com/sharer/sharer.php?app_id=${NEXT_PUBLIC_FB_APP_ID}&u=` +
      encodeURIComponent(window.location.href),
    target: '_blank',
    specs:
      'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350',
  };
  switch (value) {
    case 'facebook':
      obj.href =
        `https://www.facebook.com/sharer/sharer.php?app_id=${NEXT_PUBLIC_FB_APP_ID}&u=` +
        encodeURIComponent(window.location.href);
      break;
    case 'youtube':
      obj.href = 'https://www.youtube.com/FWDHK';
      break;
    
    case 'linkedin':
      obj.href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(window.location.href);
      break;
    
    case 'whatsapp':
      obj.href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(window.location.href);
      break;
    default:
      break;
  }
  window.open(obj.href, obj.target, obj.specs);
}

export const shareMediaURl = (value: string, currentUrl: string) => {
  let href = '';
  switch (value) {
    case 'facebook':
      href =
        `https://www.facebook.com/sharer/sharer.php?app_id=${NEXT_PUBLIC_FB_APP_ID}&u=` +
        encodeURIComponent(currentUrl);
      break;

    case 'linkedin':
      href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(currentUrl);
      break;

    case 'whatsapp':
      href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(currentUrl);
      break;
    default:
      break;
  }
  return href;
}



